import { render, staticRenderFns } from "./calling.vue?vue&type=template&id=5d9f6892&"
import script from "./calling.vue?vue&type=script&lang=js&"
export * from "./calling.vue?vue&type=script&lang=js&"
import style0 from "./calling.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports